module.exports = __webpack_public_path__ + "img/39_BF17_out_of_edge.ab968303.jpg";